import { render } from "./document-caption.vue?vue&type=template&id=30d60934"
import script from "./document-caption.vue?vue&type=script&lang=js"
export * from "./document-caption.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PC\\Codebase\\390labs\\Coverage\\legacycomposer.com\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__